<template>
    <TheModal class="sm" @close="close">
        <template slot="head">
            {{ $route.meta.title }}
            <a target="_blank" :href="getKBLink('add_ingredients')" class="btn btn-link text-nowrap ml-2 px-0"><i class="tlm-icon-question-circle" /></a>
        </template>

        <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form-thin" @submit.prevent="submit">
            <ValidationProvider v-errors.api vid="name" tag="div" class="form-group" rules="required|max:200">
                <input v-model="form.name" v-focus type="text" class="form-control" maxlength="60" placeholder="Введите название">
            </ValidationProvider>

            <ValidationProvider v-errors.api vid="unit" tag="div" class="form-group" rules="required">
                <select-unit v-model="form.unit" type="text" class="form-control multiselect-fixed" />
            </ValidationProvider>

            <div class="mt-4">
                <button type="submit" class="btn btn-primary btn-lg">{{ form.id ? 'Сохранить' : 'Создать' }}</button>
            </div>
        </ValidationObserver>
    </TheModal>
</template>

<script>
import store from '@/store'
import SelectUnit from '@/components/SelectUnit'
import TheModal from '@/components/TheModal'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mixinApiErrors } from '@/validation'

import { toastSuccess } from '@/dialogs'
import cloneDeep from 'lodash/cloneDeep'

import KBLinksService from '@/services/KBLinksService'

export default {
    components: {
        SelectUnit,
        TheModal,
        ValidationObserver,
        ValidationProvider
    },

    data() {
        return {
            form: {
                id: null,
                name: null,
                unit: null
            }
        }
    },

    methods: {
        close() {
            this.$router.push({ name: 'stocks.components' })
        },

        async submit() {
            const isValid = await this.$refs.obs.validate()

            if (!isValid) {
                return
            }

            const done = await this.$store.dispatch('components/store', this.form)

            if (done) {
                this.close()
                toastSuccess(this.form.id ? 'Ингредиент сохранен' : 'Ингредиент создан')
            } else {
                mixinApiErrors(this.$refs.obs, this.$store.state.stocks.error)
            }
        },

        getKBLink(key) {
            return KBLinksService.get(key)
        }
    },

    async beforeRouteEnter(to, from, next) {
        if (!to.params.id) {
            return next()
        }

        const component = await store.dispatch('components/fetchById', parseInt(to.params.id))

        if (component) {
            return next(vm => {
                vm.form = cloneDeep(component)
            })
        }

        return next({ name: 'stocks.components' })
    }
}
</script>
